import { LoginComponent } from "../app/components/login/login.component";


export const environment = {
    production: false,
    language: "sl",
    //wgProfileHost: "http://localhost:5000",
    //wgPlatformHost: "http://localhost:4300",
    //wgProfileHost: "https://fo-evozilatest-api.borzen.si",
    //wgPlatformHost: "https://fo-evozilatest-platform.borzen.si",
    //wgProfileHost: "https://fo-evozila-api.borzen.si",
    //wgPlatformHost: "https://fo-evozila-platform.borzen.si",
    //wgProfileHost: "https://po-evozilatest-api.borzen.si",
    //wgPlatformHost: "https://po-evozilatest-platform.borzen.si",
    //wgProfileHost: "https://po-evozila-api.borzen.si",
    //wgPlatformHost: "https://po-evozila-platform.borzen.si",
    //wgProfileHost: "https://sp-evozilatest-api.borzen.si",
    //wgPlatformHost: "https://sp-evozilatest-platform.borzen.si",
    wgProfileHost: "https://sp-evozila-api.borzen.si",
    wgPlatformHost: "https://sp-evozila-platform.borzen.si",

    loginComponent: LoginComponent,
    projIcon: "/assets/project-custom/images/logo.png",
    sidebarIcon: "/assets/project-custom/images/logo.png",
    projectCode: "BORZEN_EV",
    projectName: "",
    locale: 'sl-SI',
    useRouteAndMasterpageCache: true,
    ADLoginEnabled: false,
    dateFormat: 'DD.MM.YYYY',
    navigateAwayPopupEnabled: true,
    useEtag: true,
    newRegistrationLinkDocument: "",
    maxChunkNumber: 40,
    maxFileSizeInMb: 10,
    maxRecordNumberPerPageListing: 30,
    cacheEnabled: false,
    version: '1.1.0',
    showOnlyUserInHeader: true,
    //googleClientId: "866614170101-hp152kqqaidct6hfaeapdq1ntjm614b2.apps.googleusercontent.com", // fizince osebe evozila
    //googleClientId: "866614170101-oab513592ouvbu2q7tlplocnok6mif2c.apps.googleusercontent.com", // pravne osebe evozila
    googleClientId: "344277045222-1p1hhb7cfelg4au0dbc4vjgap4cdlfj5.apps.googleusercontent.com", // sp evozila
    useOldSearchViewFeature: false,
    usernameAlwaysToLower: true, // need this shit for EVOZILA1
    useInlineSearch: false,
    maxFileSizeInMbInMessenger: 5
};

